import Vue from 'vue'
import Router from 'vue-router'
import general from './general'
import users from './users'
import confirmations from './confirmations'
import details from './details'
import writtenSurveys from './written-surveys'
import fieldSurveys from './field-surveys'
import reports from './reports'
import admin from './admin'
import verify from './verify'
import store from '../store'

Vue.use(Router)
Vue.component('vue-router', Router)

const router = new Router({
  mode: 'history',
  routes: [
    ...general,
    ...users,
    ...confirmations,
    ...details,
    ...writtenSurveys,
    ...fieldSurveys,
    ...reports,
    ...admin,
    ...verify,
  ],
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['auth/isLoggedIn']
  const isLoginPath = to.path.indexOf('login') !== -1
    || to.path.indexOf('/password-reset') === 0
    || to.path.indexOf('/verify/') === 0

  // トークンなし＋行き先がログイン画面の場合
  if (!isLoggedIn && isLoginPath) {
    return next()
  }

  // トークンなし＋行き先がログイン画面以外の場合
  if (!isLoggedIn) {
    return next({ name: 'login' })
  }

  // トークンが有効か確認
  return store.dispatch('auth/check', { to: to.name })
    .then(() => {
      // 有効なトークン＋行き先がログイン画面の場合
      if (to.name === 'login') {
        return next({ name: 'index' })
      }

      // 有効なトークン＋行き先がログイン画面以外の場合
      return next()
    })
    .catch(() => {
      // 無効なトークン＋行き先がログイン画面の場合
      if (to.name === 'login') return next()

      // 無効なトークン＋行き先がログイン画面以外の場合
      return next({ name: 'login' })
    })
})

export default router
